import React, { useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import { FullPageOverlay } from "pu-crossproduct-components/build/components/Organisms/FullPageOverlay"
import styled from "styled-components";
import illus1 from "./illus_2FA_1.svg";
import illus2 from "./illus_2FA_2.svg";
import illus3 from "./illus_2FA_3.svg";
import illus4 from "./illus_2FA_4.svg";
import illus5 from "./illus_2FA_5.svg";
import { GridContainer, GridItem, GridRow } from "pu-crossproduct-components/build/components/Atoms/Grid";
import { Button, ButtonColors, Size } from "pu-crossproduct-components/build/components/Molecules/Navigation/Button";
import { Body4, H3 } from "pu-crossproduct-components/build/components/Atoms/Type";

interface IProps {
    open: boolean;
    onClose: () => void;
}

const Container = styled.div`
    pointer-events: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    > div {
        pointer-events: auto;
        width: 1128px;
        left: calc(50% - 564px);
        box-sizing: border-box;
        background-color: #FFFFFF;

        > div {
            background: transparent;
        }

        > div:nth-child(1) {
            margin: 0;
            padding: 16px;
            right: 0;

            svg {
                color: #169BD5;
            }
        }

        > div:nth-child(2) {
            top: -88px;
            width: 100%;
        }
    }
`;

const ButtonsContainer = styled.div`
    text-align: center;
    margin-bottom: -88px;
    
    button {
        display: inline-block;
        margin: 50px 10px;
        width: 383px;
    }
`

const TextWrapper = styled.div`
    padding: 0 30px;
    width: 452px;
    height: 400px;
    box-sizing: border-box;
    display: inline-block;
    white-space: pre-wrap;

    strong {
        color: #4ECECE;
    }
`;

const ExplanationImage = styled.img`
    width: 660px;
    height: 400px;
    object-fit: cover;
    box-sizing: border-box;
    display: inline-block;
    object-position: 0 0;
`;

const ExplanationWrapper = styled.div`
    background-color: #FFFFFF;
`;

const ExplanationLineWrapper = styled.div`
    display: flex;
`;

export const Scoodle2FAExplanation: React.FC<IProps> = props => {
    const { t } = useTranslation();

    return (
        <Container>
            <FullPageOverlay open={props.open} onClose={props.onClose}>
                <ExplanationWrapper>
                    <ExplanationLineWrapper>
                        <TextWrapper>
                            <H3><Trans t={t}>twoFactorScoodleExplanationSection1Title</Trans></H3>
                            <Body4 dangerouslySetInnerHTML={{__html: t('twoFactorScoodleExplanationSection1Body')}} />
                        </TextWrapper>

                        <ExplanationImage src={illus1} />
                    </ExplanationLineWrapper>

                    <ExplanationLineWrapper>
                        <ExplanationImage src={illus2} />

                        <TextWrapper>
                            <H3><Trans t={t}>twoFactorScoodleExplanationSection2Title</Trans></H3>
                            <Body4 dangerouslySetInnerHTML={{__html: t('twoFactorScoodleExplanationSection2Body')}} />
                        </TextWrapper>
                    </ExplanationLineWrapper>

                    <ExplanationLineWrapper>
                        <TextWrapper>
                            <H3><Trans t={t}>twoFactorScoodleExplanationSection3Title</Trans></H3>
                            <Body4 dangerouslySetInnerHTML={{__html: t('twoFactorScoodleExplanationSection3Body')}} />
                        </TextWrapper>

                        <ExplanationImage src={illus3} />
                    </ExplanationLineWrapper>

                    <ExplanationLineWrapper>
                        <ExplanationImage src={illus4} />

                        <TextWrapper>
                            <H3><Trans t={t}>twoFactorScoodleExplanationSection4Title</Trans></H3>
                            <Body4 dangerouslySetInnerHTML={{__html: t('twoFactorScoodleExplanationSection4Body')}} />
                        </TextWrapper>
                    </ExplanationLineWrapper>

                    <ExplanationLineWrapper>
                        <TextWrapper>
                            <H3><Trans t={t}>twoFactorScoodleExplanationSection5Title</Trans></H3>
                            <Body4 dangerouslySetInnerHTML={{__html: t('twoFactorScoodleExplanationSection5Body')}} />
                        </TextWrapper>

                        <ExplanationImage src={illus5} />
                    </ExplanationLineWrapper>
                </ExplanationWrapper>

                <ButtonsContainer>
                    <Button size={Size.large} onClick={props.onClose}>{t('twoFactorScoodleExplanationSectionOKButton')}</Button>
                    <Button color={ButtonColors.secondary} size={Size.large} onClick={() => window.open(t('twoFactorScoodleExplanationSectionHelpLink'))}>{t('twoFactorScoodleExplanationSectionHelpButton')}</Button>
                </ButtonsContainer>
            </FullPageOverlay>
        </Container >
    );
}